<div>
  <div>
    <h1>You will be automatically logged out once the server registers your login-status</h1>
    <p>If you are trying to login, please use the login button</p>
  </div>
  <mat-spinner class="spinner"></mat-spinner>
</div>